<template>
    <div>

        <div v-if="!em_edicao">

            <div class="card dashcard mb-3">
                <div class="card-body">
                    <div class="form-row">
                        <div class="col col-12 col-md-6">
                            <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                icon="fas fa-warehouse"
                                placeholder="Selecione o Local..."
                                type="select"
                                service="estoque_locals.index"
                                optionsData="id_estoque_local"
                                optionsMode="aql"
                                v-model="filtros.id_estoque_local"
                                @input="load()" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                type="button-group"
                                :optionsList="[{id:'A',search:'Ativos'},{id:'T',search:'Todos'}]"
                                v-model="viewMode" />
                        </div>
                    </div>

                    <div class="form-row mt-2">
                        <div class="col col-12">
                            <az-input
                                icon="fa fa-search"
                                placeholder="Pesquisar por (ou digite # + número do inventário)..."
                                v-model="search">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-outline-primary" @click="incluir ()">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <template v-if="!em_edicao">

            <div v-if="( !lista || !lista.length )">
                <az-empty-state
                    :msg="'Nenhum inventário identificado.'"
                    icon="fas fa-boxes"
                    :action="'Incluir Item'"
                    :method="incluir" />
            </div>

            <div v-else>

                <div class="progress mt-0 mb-2">
                    <div class="indeterminate" v-if="$store.state.loading"></div>
                    <div class="determinate" v-else></div>
                </div>

                <div class="list-group mb-3 az-anime-surgir mb-3">
                    <li class="list-group-item d-flex justify-content-between hover-bg" :class="dado.fl_ativo ? '' : 'list-group-item-secondary'"
                        v-for="(dado, id) in lista" :key="id">
                        <span>
                            <a href="#" @click.prevent="lancar_contagem(dado)" class="h5 card-link mb-0 mr-3"
                                v-if="dados">
                                {{ dado.search }}
                            </a>
                            <span class="badge badge-secondary">
                                {{ dado.estoque_inventario_items_count }}
                            </span>
                        </span>
                        <span>
                            <div v-if="dado.fl_encerrado">
                                <span>
                                    <i class="fas fa-check text-success"></i>
                                </span>
                            </div>
                            <div class="custom-control custom-switch" v-else-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input"
                                    :id="'ativo-' + id"
                                    v-model="dado.fl_ativo"
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>

                        </span>
                    </li>
                </div>

            </div>

            <az-wiki topic="Inventário" />

        </template>

        <div v-else-if="em_edicao">

            <template v-if="!contagem">
                <az-empty-state msg="Aguarde..." />
            </template>

            <template v-else>

                <div v-if="!contagem.fl_ativo">
                    <p class="alert alert-danger">Inventário Inativo</p>
                </div>

                <div class="card">
                    <div class="card-header d-flex justify-content-between">
                        <div>{{ contagem.search }}</div>
                        <div v-if="contagem.fl_ativo && !contagem.fl_encerrado">
                            <importacao 
                                service="estoque_inventario_items"
                                :parms="{
                                    id_estoque_inventario: contagem.id_estoque_inventario,
                                }"
                                @refresh="lancar_contagem(contagem, true)" />
                        </div>
                    </div>

                    <div class="card-body" v-if="!finalizando && !contagem.fl_encerrado">

                        <template v-if="contagem.estoque_inventario_items.filter(item => !item.excluido).length">
                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        icon="fa fa-search fa-fw"
                                        placeholder="Pesquisar..."
                                        v-model="search_items">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <print-export sizing="sm" printid="lista_print" />
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <selecao-material @selecionado="filtrar_item" :entrada="true" :infoqt="false" :barcode_only="true" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="button-group"
                                        :optionsList="[
                                            { id: 'A', search: 'Alfabética' },
                                            { id: 'L', search: 'Lançamento' },
                                        ]"
                                        v-model="ordem_contagem"
                                        @input2="trocar_ordem()" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        icon="fa-solid fa-list-ol fa-fw"
                                        type="select"
                                        placeholder="Contagem Final"
                                        :optionsList="[
                                            { id: '1', search: '1a. Contagem' },
                                            { id: '2', search: '2a. Contagem' },
                                            { id: '3', search: '3a. Contagem' },
                                            { id: 'R', search: 'Resumo Final' }, 
                                        ]"
                                        optionsData="id"
                                        v-model="num_contagem" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        placeholder="Todos"
                                        sizing="sm"
                                        icon="fa-solid fa-filter fa-fw"
                                        type="select"
                                        :optionsList="lista_filtro_contagem"
                                        optionsData="id"
                                        v-model="filtro_contagem" />
                                </div>
                                <div class="col col-12 col-md-3 d-flex flex-column" v-if="num_contagem == 'R'">
                                    <button type="button" class="btn btn-sm btn-outline-primary" @click="definir_contagem_final()">
                                        Atualizar Contagem Final
                                    </button>
                                </div>
                                <div class="col col-12 col-md-3" v-else>
                                    <button type="button" class="btn btn-sm btn-outline-primary" @click="pue_selecinados()" title="Precificar pelo Preço da Última Entrada (PUE)">
                                        PUE
                                    </button>
                                </div>
                            </div>
                        </template>

                        <div v-else-if="!contagem.fl_ativo">
                            <div>Nenhum item registrado.</div>
                        </div>

                        <div class="mb-2">
                            <span class="badge badge-secondary mr-2" title="Quantidade de Itens">{{ lista_contagem_items.length }}</span>

                            <a href="#" @click.prevent="search_items == '&quot;' + tag + '&quot;' ? search_items = '' : search_items = '&quot;' + tag + '&quot;'" v-for="(tag, itx) in lista_tags" :key="itx">
                                <span class="badge badge-success mr-1" >
                                    {{ tag }}
                                </span>
                            </a>
                        </div>

                        <div id="lista_print" class="d-none d-print-block">

                            <cabecalho-generico titulo="Inventário">
                                <div>{{ contagem.search }}</div>
                            </cabecalho-generico>

                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Lote</th>
                                        <th v-if="exibir_localizacao">Local</th>
                                        <th class="text-right">Quantidade</th>
                                        <th>Preço</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(contagem_item, itx) in lista_contagem_items" :key="itx">
                                        <td>
                                            {{ contagem_item.estoque_item.search }}
                                        </td>
                                        <td width="15%">
                                            <span v-if="contagem_item.estoque_item.fl_controla_lote">
                                                {{ contagem_item.st_lote }}
                                            </span>
                                        </td>
                                        <td v-if="exibir_localizacao"><template v-if="contagem_item.estoque_item && contagem_item.estoque_item.limite && contagem_item.estoque_item.limite.st_local">{{ contagem_item.estoque_item.limite.st_local }}</template></td>
                                        <td class="text-right" width="20%">
                                            {{ contagem_item.estoque_item.st_unidade_estoque }}
                                        </td>
                                        <td width="20%">
                                            R$
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <template v-if="num_contagem == 'R'">
                            <table class="table table-sm table-hover small">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Lote</th>
                                        <th>Validade</th>
                                        <th>Unidade</th>
                                        <th class="text-right">1a. Contagem</th>
                                        <th class="text-right">2a. Contagem</th>
                                        <th class="text-right">3a. Contagem</th>
                                        <th class="text-right">Final</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(contagem_item, itx) in lista_contagem_items" :key="itx" :class="divergente(contagem_item) ? 'table-warning' : ''">
                                        <td>{{ contagem_item.estoque_item.search }}</td>
                                        <td>
                                            <span v-if="contagem_item.estoque_item.fl_controla_lote">
                                                {{ contagem_item.st_lote }}       
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="contagem_item.estoque_item.fl_controla_lote && contagem_item.dt_validade">
                                                {{ $util.getFormatDate(contagem_item.dt_validade) }}
                                            </span>
                                        </td>
                                        <td>
                                            {{ contagem_item.estoque_item.st_unidade_estoque }}
                                        </td>
                                        <td class="text-right">
                                            {{ contagem_item.in_contagem_1 }}
                                        </td>
                                        <td class="text-right">
                                            {{ contagem_item.in_contagem_2 }}
                                        </td>
                                        <td class="text-right">
                                            {{ contagem_item.in_contagem_3 }}
                                        </td>
                                        <td class="text-right">
                                            {{ contagem_item.in_quantidade }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>

                        <template v-else>
                            <div class="form-row" v-for="(contagem_item, itx) in lista_contagem_items" :key="itx">
                                <div class="col col-12" :class="contagem_item.estoque_item.fl_controla_lote ? 'col-md-4' : 'col-md-8'">
                                    <az-input
                                        icon="fa fa-minus"
                                        buttonText="fas fa-minus fa-fw"
                                        :buttonIcon="true"
                                        buttonColor="outline-danger"
                                        sizing="sm"
                                        :edicao="false"
                                        v-model="contagem_item.estoque_item.search"
                                        @clickButton="contagem_item.excluido = true">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text">
                                                    #{{ contagem_item.id_estoque_item }}
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                    <div v-if="exibir_localizacao && contagem_item.estoque_item && contagem_item.estoque_item.limite && contagem_item.estoque_item.limite.st_local" class="small text-muted mb-2" title="Localização.">
                                        <i class="fa-regular fa-map mr-1"></i>
                                        {{ contagem_item.estoque_item.limite.st_local }}
                                    </div>
                                </div>
                                <template v-if="contagem_item.estoque_item.fl_controla_lote">
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            :icon="contagem_item.st_lote ? '' : 'fas fa-tag fa-fw'"
                                            buttonToolTip="Lote"
                                            placeholder="Lote..."
                                            sizing="sm"
                                            :edicao="contagem_item.estoque_item.fl_controla_lote"
                                            v-model="contagem_item.st_lote"
                                            @input="editado = true">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend" v-if="contagem_item.st_lote">
                                                    <button class="btn btn-outline-secondary" type="button" id="button-addon1"
                                                        data-toggle="tooltip" data-placement="top" title="Incluir outro lote."
                                                        @click.prevent="incluir_novo_lote(contagem_item, itx)">
                                                        <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            icon="far fa-calendar-check"
                                            buttonToolTip="Validade"
                                            type="date"
                                            sizing="sm"
                                            :edicao="!!contagem_item.st_lote && contagem_item.st_lote != 'Sem Lote' && contagem_item.estoque_item.fl_controla_lote"
                                            :required="!!contagem_item.st_lote && contagem_item.st_lote != 'Sem Lote' && contagem_item.estoque_item.fl_controla_lote"
                                            nrules="['futuro']"
                                            v-model="contagem_item.dt_validade"
                                            :validate="validate"
                                            @input="editado = true" />
                                    </div>
                                </template>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        label="F"
                                        :compact="true"
                                        v-if="!num_contagem"
                                        :key="'kqtd' + itx"
                                        buttonToolTip="Quantidade"
                                        placeholder="Quantidade..."
                                        type="number"
                                        sizing="sm"
                                        v-model="contagem_item.in_quantidade"
                                        :iconEnd="contagem_item.estoque_item.st_unidade_estoque ? { text: contagem_item.estoque_item.st_unidade_estoque } : null"
                                        :validate="validate"
                                        @input="editado = true"
                                        :ref="'invqtd' + itx"
                                        @onEnter="focusOn('invqtd' + ( itx + 1 ))" />

                                    <az-input
                                        :label="num_contagem + 'a.'"
                                        :compact=true
                                        v-if="num_contagem == '1' || num_contagem == '2' || num_contagem == '3'"
                                        :key="'kqtd' + itx"
                                        buttonToolTip="Quantidade"
                                        placeholder="Quantidade..."
                                        type="number"
                                        sizing="sm"
                                        v-model="contagem_item['in_contagem_' + num_contagem]"
                                        :iconEnd="contagem_item.estoque_item.st_unidade_estoque ? { text: contagem_item.estoque_item.st_unidade_estoque } : null"
                                        :validate="validate"
                                        @input="editado = true"
                                        :ref="'invqtd' + itx"
                                        @onEnter="focusOn('invqtd' + ( itx + 1 ))" />
                                </div>
                                <div class="col col-12 col-md-2" v-if="!trocando_ordem">
                                    <az-input
                                        :key="'pm' + itx"
                                        placeholder="Preço Médio..."
                                        type2="trocando_ordem ? 'number' : 'money'"
                                        type="number"
                                        sizing="sm"
                                        v-if="( contagem_item.id_estoque_inventario_item && !contagem_item.estoque_item.estoque_movimentacoes_count ) || ( contagem_item.prec )"
                                        v-model="contagem_item.dc_preco_medio"
                                        :validate="validate"
                                        @input="editado = true"
                                        @onEnter="focusOn('invqtd' + ( itx + 1 ))">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon1">R$</span>
                                            </div>
                                        </template>
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="( contagem_item.estoque_item && contagem_item.estoque_item.ultima_entrada && contagem_item.estoque_item.ultima_entrada.dc_valor && !contagem_item.dc_preco_medio )">
                                                <button type="button" class="btn btn-sm btn-outline-secondary" @click="contagem_item.dc_preco_medio = contagem_item.estoque_item.ultima_entrada.dc_valor" :title="'Utilizar o preço da última entrada: R$ ' + $util.formatMoeda(contagem_item.estoque_item.ultima_entrada.dc_valor)">
                                                    PUE
                                                </button>
                                            </div>

                                            <div class="input-group-append" v-if="( contagem_item.id_estoque_inventario_item && contagem_item.estoque_item.estoque_movimentacoes_count )">
                                                <button type="button" class="btn btn-sm btn-outline-danger" @click="remover_preco_medico(contagem_item)" title="Remover precificação.">
                                                    <i class="fa-regular fa-rectangle-xmark"></i>
                                                </button>
                                            </div>                                           
                                        </template>
                                    </az-input>

                                    <button type="button" class="btn btn-sm btn-outline-primary" @click="contagem_item.prec = !contagem_item.prec" v-else>
                                        <i class="fa-solid fa-dollar-sign mr-2"></i>
                                        Precificar
                                    </button>
                                </div>
                            </div>

                            <div class="row mt-2" v-if="1 == 0 && contagem.fl_ativo && !contagem.fl_encerrado">
                                <div class="col col-12">
                                    <az-input
                                        placeholder="Selecione o material..."
                                        sizing="sm"
                                        icon="fas fa-plus"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        service="estoque_items.index"
                                        :optionsSync="false"
                                        v-model="novo_item"
                                        @selecionado="incluir_item_contagem" />
                                </div>
                            </div>

                            <div class="mt-2" v-if="contagem.fl_ativo && !contagem.fl_encerrado">
                                <selecao-material @selecionado="incluir_item_contagem" :entrada="true" :entrada_buscar_lotes="true" :infoqt="true" />
                            </div>

                        </template>

                        <div v-if="1 == 0">
                            <hr>
                            <pre>{{ contagem }}</pre>
                        </div>
                    </div>

                    <div class="card-body" v-else>

                        <div class="row mb-3">
                            <div class="col col-12 col-md-6 d-flex">
                                <print-export printid="diferenca_print" :dados="dados_exportacao" />
                                <button type="button" class="btn btn-outline-primary ml-2 mb-1" v-if="contagem.fl_encerrado" @click="clonar(contagem)">
                                    Clonar
                                </button>
                                <button type="button" class="btn btn-outline-primary ml-2 mb-1"  @click="emitir_etiqueta(lista_contagem_items)">
                                    Etiquetas
                                </button>
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    v-if="!contagem || !contagem.fl_encerrado"
                                    type="checkbox-group"
                                    label="Retroativo"
                                    v-model="retroativo" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    v-if="( !contagem || !contagem.fl_encerrado ) && retroativo"
                                    type="date"
                                    icon="far fa-calendar-alt"
                                    required
                                    :validate="validate"
                                    v-model="dt_retroativo" />
                            </div>
                        </div>

                        <div id="diferenca_print">

                            <div class="d-none d-print-block">
                                <cabecalho-generico titulo="Inventário / Diferenças">
                                    <div>{{ contagem.search }}</div>
                                </cabecalho-generico>
                            </div>

                            <table class="table table-striped mb-0 cabecalho-fixo">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Descrição</th>
                                        <th>Lote</th>
                                        <th>Validade</th>
                                        <th>Unidade</th>
                                        <th class="text-right">Contagem</th>
                                        <th class="text-right">Saldo</th>
                                        <th class="text-right">{{ contagem.fl_encerrado ? 'Movimentado' : 'Movimentar' }}</th>
                                        <th class="text-right">Divergência</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, itx) in lista_contagem_items" :key="itx">
                                        <td>{{ item.id_estoque_item }}</td>
                                        <td>{{ item.estoque_item.search }}</td>
                                        <td>
                                            <span v-if="item.estoque_item.fl_controla_lote">
                                                {{ item.st_lote }}
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="item.estoque_item.fl_controla_lote && item.st_lote != 'Sem Lote'">
                                                {{ $util.getFormatDate(item.dt_validade) }}
                                            </span>
                                        </td>
                                        <td>
                                            <small class="text-muted">
                                                {{ item.estoque_item.st_unidade_estoque }}
                                            </small>
                                            <div class="small text-muted">
                                                {{ $util.formatMoeda(item.preco) }}
                                            </div>
                                        </td>
                                        <td class="text-right">
                                            {{ item.in_quantidade }}
                                            <div class="small text-muted text-nowrap">
                                                {{ $util.formatMoeda(item.preco * item.in_quantidade) }}
                                            </div>
                                        </td>
                                        <td class="text-right">
                                            <span v-if="1 == 1 || contagem.fl_encerrado">
                                                {{ item.in_saldo }}
                                                <div class="small text-muted">
                                                    <span v-if="!item.in_saldo && item.preco_atual">
                                                        {{ $util.formatMoeda(item.preco_atual) }}
                                                    </span>
                                                    <span v-else>
                                                        {{ $util.formatMoeda(item.preco_atual * item.in_saldo) }}
                                                    </span>
                                                </div>
                                            </span>
                                            <span v-else-if="item.estoque_item.saldo">
                                                {{ item.estoque_item.saldo.qtd }}
                                                <div class="small text-muted">
                                                    {{ $util.formatMoeda(item.preco * item.estoque_item.saldo.qtd) }}
                                                </div>
                                            </span>
                                            <span v-else>-</span>
                                        </td>
                                        <td class="text-right">
                                            {{ item.qt_movimentar }}
                                            <i class="fa fa-plus-circle text-success ml-2" aria-hidden="true" v-if="item.qt_movimentar > 0"></i>
                                            <i class="fa fa-minus-circle text-danger ml-2" aria-hidden="true" v-else-if="item.qt_movimentar < 0"></i>
                                            <i class="fa-solid fa-circle-exclamation text-warning ml-2" aria-hidden="true" v-else-if="item.qt_movimentar == 0 && item.vl_movimentar"></i>
                                            <i class="fa fa-check-circle text-primary ml-2" aria-hidden="true" v-else-if="item.qt_movimentar == 0"></i>
                                            <div class="small text-muted">
                                                {{ $util.formatMoeda(item.vl_movimentar) }}
                                            </div>
                                        </td>
                                        <td class="text-right">
                                            <span v-if="item.estoque_item.saldo && item.estoque_item.saldo.qtd > 0">
                                                {{ divergencia(item) }}%
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="5">Total <span class="badge badge-secondary ml-2">{{ lista_contagem_items.length }}</span></td>
                                        <td class="text-right">{{ $util.formatMoeda(totalizar(lista_contagem_items, 'contagem')) }}</td>
                                        <td class="text-right">{{ $util.formatMoeda(totalizar(lista_contagem_items, 'saldo')) }}</td>
                                        <td class="text-right">{{ $util.formatMoeda(totalizar(lista_contagem_items, 'diferenca')) }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="8">
                                            Acuracidade: {{ acuracidade }}%
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>

                            <pre v-if="false">{{ contagem }}</pre>

                        </div>

                    </div>

                </div>

                <!-- Botões de Atualização -->

                <nav class="navbar fixed-bottom navbar-light bg-light pb-3">

                    <div class="d-flex">
                        <az-submit class="mr-2" @click="atualizar_contagem ()" v-if="contagem.fl_ativo && !contagem.fl_encerrado">Atualizar</az-submit>
                        <button class="btn btn-secondary mr-2" @click="fechar ()">Fechar</button>
                        <az-audit-log-button model="estoqueInventario" :id="contagem.id_estoque_inventario" />
                        <button class="btn btn-outline-secondary mx-2" @click="incluir_itens()" v-if="contagem.fl_ativo && !contagem.fl_encerrado">
                            Incluir Itens
                        </button>
                        <az-input 
                            type="checkbox-group"
                            label="Exibir Localização"
                            v-model="exibir_localizacao" />

                        <span class="badge ml-3" :class="editado ? 'text-muted' : 'text-success'">
                            <i class="fa fa-check-circle" aria-hidden="true"></i>
                        </span>
                    </div>

                    <div class="btn-group dropup">
                        <az-submit color="danger" v-if="!finalizando && !contagem.fl_encerrado" @click="finalizar()">
                            <i class="fas fa-power-off mr-2" v-if="!$store.state.loading"></i>
                            Finalizar Inventário
                        </az-submit>

                        <template v-else-if="finalizando && !contagem.fl_encerrado">

                            <button class="btn btn-secondary mr-2" type="button" @click="finalizando = false">
                                <i class="fas fa-chevron-left mr-2"></i>
                                Voltar
                            </button>

                            <az-submit color="success" @click="realizar()">
                                <i class="fa fa-play mr-2" aria-hidden="true"></i>
                                Realizar Movimentações
                            </az-submit>

                        </template>

                    </div>

                </nav>

            </template>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            <span v-if="item && item.id_estoque_inventario_clone">
                                Clonar Inventário #{{ item.id_estoque_inventario_clone }}
                            </span>
                            <template v-else>
                                {{ item && item.id_estoque_inventario ? '' : 'Novo' }}
                                Inventário
                                <span class="badge badge-secondary ml-1" v-if="item && item.id_estoque_inventario">
                                    #{{ item.id_estoque_inventario }}
                                </span>
                            </template>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row mb-3">
                            <div class="col col-12">
                                <az-input
                                    label="Título"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col col-12">
                                <az-input
                                    label="Local de Armazenagem"
                                    type="select"
                                    service="estoque_locals.index"
                                    optionsData="id_estoque_local"
                                    optionsMode="aql"
                                    :validate="validate"
                                    required
                                    v-model="item.id_estoque_local" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação"
                                    type="textarea"
                                    rows="5"
                                    v-model="item.st_observacao" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_estoque_inventario ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Incluir Itens -->
        <div class="modal fade" id="incluirItensModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="inclusao">
                    <div class="modal-header">
                        <h5 class="modal-title">Incluir Itens</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    placeholder="Todos..."
                                    sizing="sm"
                                    type="select"
                                    label="Grupo"
                                    service="estoque_grupos.index"
                                    optionsMode="aql"
                                    optionsDisplay="search"
                                    optionsData="id_estoque_grupo"
                                    v-model="inclusao.id_estoque_grupo" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Apenas itens já movimentados neste local"
                                    v-model="inclusao.movimentados" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    :label="'Todos os materiais ' + ( inclusao.id_estoque_grupo ? 'do grupo' : '' )"
                                    v-model="inclusao.todos" />
                            </div>
                        </div>

                        <div class="mt-3" v-if="!inclusao.todos">
                            <div v-for="(tag, itx) in inclusao.tags" :key="itx">
                                <az-input
                                    type="checkbox-group"
                                    :label="tag.tag"
                                    v-model="tag.selecionada" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_inclusao()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <estoque-etiqueta ref="estoque_etiqueta" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
// import * as moment from 'moment';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import SelecaoMaterial from './SelecaoMaterial.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzWiki from '../../util/AzWiki.vue';
import EstoqueEtiqueta from './EstoqueEtiqueta.vue';
import Importacao from '../../cadastros/shared/Importacao.vue';

export default {
    data () {
        return {
            dados: null,
            em_edicao: false,
            item: null,
            validate: false,
            search: "",
            viewMode: "A",
            title: "",
            short_title: "",
            service: "",
            metadados: null,
            anos: [],
            unidade: "",
            contagem: null,
            novo_item: "",
            search_items: "",
            finalizando: false,
            filtros: {
                inicio: "",
                fim: "",
                periodo: "m",
                id_estoque_local: this.$util.getCookie('estoque-armazem'),
            },
            inclusao: null,
            ordem_contagem: 'L',
            trocando_ordem: false,
            editado: false,
            timeout: null, 
            retroativo: false, 
            dt_retroativo: null,
            num_contagem: "", 
            filtro_contagem: "", 
            exibir_localizacao: false, 
        }
    },

    props: ['cadastro'],

    components: {
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        AzPeriodo,
        SelecaoMaterial,
        PrintExport,
        CabecalhoGenerico,
        AzWiki,
        EstoqueEtiqueta,
        Importacao, 
    },

    computed: {
        tem_localizacao: function () { 
            if ( !this.lista_contagem_items || !this.lista_contagem_items.length ) { 
                return false; 
            }

            return this.lista_contagem_items.some(item => item.estoque_item && item.estoque_item.limite && item.estoque_item.limite.st_local) ? true : false; 
        },

        dados_exportacao: function () { 
            if ( !this.lista_contagem_items )
                return [];

            return this.lista_contagem_items.map(item => {
                return {
                    id: item.id_estoque_inventario_item, 
                    id_item: item.id_estoque_item,
                    descricao: item.estoque_item.search,
                    lote: item.estoque_item.fl_controla_lote ? item.st_lote : '',
                    validade: ( item.estoque_item.fl_controla_lote && item.dt_validade ) ? this.$util.getFormatDate(item.dt_validade) : '',
                    unidade: item.estoque_item.st_unidade_estoque,
                    preco: this.$util.formatMoeda(item.preco),
                    contagem: item.in_quantidade,
                    saldo: item.in_saldo,
                };
            });
        },

        lista_filtro_contagem: function () { 
            switch (this.num_contagem) {
                case '2':
                    return [
                        { id: 'C', search: 'Contados na primeira / saldo divergente' },
                    ];

                case '3':
                    return [
                        { id: 'C', search: 'Divergentes entre a primeira e a segunda contagem' },
                    ];

                case 'R': 
                    return [
                        { id: 'C', search: 'Contados' },
                        { id: 'D', search: 'Divergentes' },
                    ];

                default: 
                    return [
                        { id: 'C', search: 'Contados' },
                    ];
            }
        },

        acuracidade: function () {
            if ( this.lista_contagem_items && this.lista_contagem_items.length > 0 ) {
                return Math.round((
                    this.lista_contagem_items.filter(item => item.in_quantidade - item.in_saldo == 0).length
                    / this.lista_contagem_items.length
                ) * 100);
            }

            return "";
        },

        lista_tags: function () {

            return  _.orderBy(
                _.uniq(
                    this.lista_contagem_items.flatMap(item => item.estoque_item.js_classes ? item.estoque_item.js_classes : [])
                )
            );

            /*
            this.lista_contagem_items.reduce((carry, item) => {
                        return item.estoque_item.js_classes ? carry.concat(item.estoque_item.js_classes) : carry;
                    }, [])
                    */

        },

        lista_contagem_items: function () {

            if ( !this.contagem )
                return [];

            let lista = this.contagem.estoque_inventario_items
                .filter(item => !item.excluido)
                .filter(item => !this.search_items || JSON.stringify(item).toUpperCase().indexOf(this.search_items.toUpperCase()) >= 0);

            this.$nextTick(() => {
                //this.trocando_ordem = false;
            });

            if ( this.filtro_contagem == 'C' ) { 
                switch (this.num_contagem) {
                    case '3':
                        lista = lista.filter(item => item.in_contagem_1 != item.in_contagem_2 && ( item.in_contagem_2 || item.in_contagem_2 === 0 ) );
                        break;

                    case '2':
                        lista = lista.filter(item => item.in_contagem_1 && ( item.in_contagem_1 || item.in_contagem_1 === 0 ) 
                            && ( !this.check_saldo(item) ));
                        break;

                    case '1': 
                    case 'R':
                        lista = lista.filter(item => item.in_contagem_1 && ( item.in_contagem_1 || item.in_contagem_1 === 0 ) );
                        break;

                    default:
                        lista = lista.filter(item => item.in_quantidade && ( item.in_quantidade || item.in_quantidade === 0 ) );
                        break;
                }
            }

            if ( this.filtro_contagem == 'D' && this.num_contagem == 'R' ) { 
                lista = lista.filter(item => this.divergente(item));
            }
            
            return this.ordem_contagem == 'A'
                ? _.orderBy(lista, 'estoque_item.search')
                : _.orderBy(lista, 'ordem_lanc');

        },

        lista: function () {
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ?
                this.dados.filter (item => {
                    return ( this.viewMode == 'T' || item.fl_ativo ) &&
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        }
    },

    methods: {
        check_saldo (item) { 

            if ( !item.in_contagem_1 ) { 
                return false;
            }

            let saldo = null;

            if ( item.st_lote == 'Sem Lote' ) { 
                saldo = item.estoque_item.saldo ? item.estoque_item.saldo.qtd : null;
            } else { 
                let lote = item.estoque_item.saldo_por_lote.find(lote => lote.st_lote == item.st_lote);

                if ( lote ) {
                    saldo = lote.qtd;
                } 
            }

            if ( saldo !== null && saldo == item.in_contagem_1 ) { 
                return true;
            }

            return false;

        },

        pue_selecinados () { 
            if ( !confirm('Confirma precificar os itens pelo preço da última entrada?') ) { 
                return;
            }

            _.each(this.lista_contagem_items, item => { 

                if ( item.estoque_item && item.estoque_item.ultima_entrada && item.estoque_item.ultima_entrada.dc_valor && !item.dc_preco_medio) { 
                    item.prec = true; 
                    item.dc_preco_medio = item.estoque_item.ultima_entrada.dc_valor;
                }

            });
        },

        divergente(item) {
            if ( ( item.in_contagem_3 || item.in_contagem_3 === 0 ) && 
                item.in_contagem_3 !== item.in_contagem_2 &&
                item.in_contagem_3 !== item.in_contagem_1 &&
                item.in_contagem_2 !== item.in_contagem_1 ) { 

                return true;

            } 

            if ( ( !item.in_contagem_3 && item.in_contagem_3 !== 0 ) && 
                ( item.in_contagem_2 || item.in_contagem_2 === 0 ) &&
                ( item.in_contagem_2 !== item.in_contagem_1 ) ) { 

                return true;

            } 

            return false;
        },

        definir_contagem_final () { 
            this.lista_contagem_items.forEach(item => {
                if ( item.in_contagem_3 || item.in_quantidade === 0 ) { 
                    if ( item.in_contagem_3 === item.in_contagem_2 || item.in_contagem_3 === item.in_contagem_1 ) { 
                        item.in_quantidade = item.in_contagem_3;
                    } else if ( item.in_contagem_2 === item.in_contagem_1 ) { 
                        item.in_quantidade = item.in_contagem_2;
                    } else { 
                        item.in_quantidade = item.in_contagem_3;
                    }
                } else if ( item.in_contagem_2 || item.in_quantidade === 0 ) { 
                    item.in_quantidade = item.in_contagem_2;
                } else if ( item.in_contagem_1 || item.in_quantidade === 0 ) { 
                    item.in_quantidade = item.in_contagem_1;
                }
            });
        },

        filtrar_item (item) {
            if ( item ) {  
                this.search_items = '"' + item.search + '"';
            } else { 
                this.search_items = "";
            }
        },

        remover_preco_medico (contagem_item) { 
            contagem_item.prec = false; 

            this.$nextTick(() => { 
                contagem_item.dc_preco_medio = null;
            });
        },

        emitir_etiqueta(items) {
             const etiquetaItens = items
                .map(lote => {
                    return {
                        checked: false,
                        id_estoque_item: lote.id_estoque_item,
                        lote: lote.estoque_item && lote.estoque_item.fl_controla_lote ? lote.st_lote : '',
                        validade: lote.dt_validade ? lote.dt_validade : '',
                        qtde: lote.in_quantidade,
                        search: lote.estoque_item && lote.estoque_item.search ? lote.estoque_item.search : '',
                    }
                });

            this.$refs.estoque_etiqueta.show(etiquetaItens);
        },

        divergencia(item) {
            return Math.round( ( Math.abs(item.in_quantidade - item.in_saldo) / item.estoque_item.saldo.qtd ) * 100 );
        },

        totalizar(lista, campo) {
            return lista.reduce((total, carry) => {
                switch (campo) {
                    case 'contagem': return total + (parseFloat(carry.preco ? carry.preco : 0) * parseFloat(carry.in_quantidade ? carry.in_quantidade : 0));
                    case 'saldo': return total + (parseFloat(carry.preco_atual ? carry.preco_atual : 0) * parseFloat(carry.in_saldo ? carry.in_saldo : 0));
                    case 'diferenca': return total + (parseFloat(carry.vl_movimentar ? carry.vl_movimentar : 0));
                }

                /*
                switch (campo) {
                    case 'contagem': return total + (parseFloat(carry.preco) * parseFloat(carry.in_quantidade));
                    case 'saldo': return total + (parseFloat(carry.preco) * parseFloat(carry.in_saldo));
                    case 'diferenca': return total + (parseFloat(carry.preco) * parseFloat(this.calc_qt_movimentar(carry)));
                }*/

                return 0;
            }, 0);
        },
        incluir_novo_lote(contagem_item, index = 0) {
            $('[data-toggle="tooltip"]').tooltip('dispose');

            if ( contagem_item ) {
                this.contagem.estoque_inventario_items.splice(index + 2, 0, {
                    id_estoque_inventario_item: null,
                    id_estoque_item: contagem_item.id_estoque_item,
                    estoque_item: contagem_item.estoque_item,
                    in_quantidade: "",
                    st_lote: "",
                    dt_validade: "",
                    excluido: false,
                    ordem_lanc: contagem_item.ordem_lanc,
                    prec: false, 
                });

                this.editado = true;
            }

            this.$nextTick(() => {
                this.novo_item = "";
            });
        },

        focusOn (item) {

            if ( this.$refs[item] && this.$refs[item][0] ) {
                this.$refs[item][0].$refs.input.focus ();
            }

        },

        trocar_ordem() {
            this.trocando_ordem = true;

            if (this.timeout) { 
                clearTimeout(this.timeout); 
                this.timeout = null;
            }

            this.$nextTick(() => {
                this.timeout = setTimeout(() => { 
                    this.trocando_ordem = false;    
                }, 400);
            });
        },

        atualizar_inclusao() {
            if ( !confirm('Confirma a inclusão dos items?') ) {
                return;
            }

            this.$util.atualizar(this, {
                service: 'estoque_inventarios',
                func: 'incluir_inventario_items',
                dados: {
                    ...this.inclusao,
                    id_estoque_inventario: this.contagem.id_estoque_inventario,
                },
                modal: 'incluirItensModal',
                toast: true,
                callback: () => {
                    this.lancar_contagem(this.contagem, true);
                }
            });
        },

        incluir_itens() {
            if ( !this.inclusao ) {

                this.inclusao = {
                    todos: true,
                    movimentados: false, 
                    tags: [],
                    id_estoque_grupo: "",
                };

                this.$util.loadItem(this, {
                    service: 'estoque_items',
                    func: 'tags',
                })
                .then(res => {
                    this.inclusao.tags = res.map(item => {
                        return {
                            tag: item,
                            selecionada: false,
                        };
                    });
                });

            }

            $('#incluirItensModal').modal('show');
        },

        calc_qt_movimentar(item) {
            return item.in_quantidade - item.in_saldo;

            /*
            if ( this.contagem.fl_encerrado ) {
                return item.in_quantidade - item.in_saldo;
            }
            return item.in_quantidade - ( item.estoque_item.saldo ? item.estoque_item.saldo.qtd : 0 );
            */
        },

        realizar() {
            if ( !confirm('Confirma realizar as movimentações conforme contagem do inventário?') )
                return;

            this.$util.atualizar(this, {
                service: 'estoque_inventarios',
                func: 'realizar_mov',
                redir_api: true, 
                dados: {
                    ...this.contagem,
                    dt_retroativo: this.retroativo ? this.dt_retroativo : null,
                },
                toast: true,
                callback: () => {
                    this.finalizar();
                }
            });
        },

        finalizar () {
            if ( this.editado ) {
                this.$toast.add({
                    severity: "warn",
                    summary: "Finalizar",
                    detail: "Necessário salvar os dados editados para finalizar o inventário.",
                    life: 3000
                });
                return;
            }

            this.search_items = "";

            this.$util.load(this, {
                service: "estoque_inventarios.show",
                parms: {
                    id: this.contagem.id_estoque_inventario,
                    id_estoque_local: this.contagem.id_estoque_local,
                    contagem: true,
                    saldos: true,
                },
                loadTo: res => {
                    this.contagem = res;
                    this.finalizando = true;
                }
            });
        },

        atualizar_contagem() {
            this.$util.atualizar(this, {
                service: 'estoque_inventarios',
                dados: {
                    ...this.contagem
                },
                toast: true,
                callback: () => {
                    this.lancar_contagem(this.contagem, true);
                }
            });
        },

        incluir_item_contagem (novo_item) {
            if ( novo_item ) {

                let teste;

                if ( novo_item.fl_controla_lote ) { 
                    teste = this.contagem.estoque_inventario_items.find(item => item.id_estoque_item == novo_item.id_estoque_item
                        && novo_item.lote
                        && item.st_lote == novo_item.lote.numero
                        && !item.excluido);    
                } else { 
                    teste = this.contagem.estoque_inventario_items.find(item => item.id_estoque_item == novo_item.id_estoque_item && !item.excluido);
                }

                if ( teste ) {

                    this.search_items = teste.estoque_item.st_estoque_item;

                } else { 

                    this.search_items = "";

                    let item_inclusao = {
                        id_estoque_inventario_item: null,
                        id_estoque_item: novo_item.id_estoque_item,
                        estoque_item: novo_item,
                        in_quantidade: null,
                        in_contagem_1: null,
                        in_contagem_2: null,
                        in_contagem_3: null,
                        st_lote: _.get(novo_item, 'lote.numero'),
                        dt_validade: _.get(novo_item, 'lote.validade'),
                        excluido: false,
                        ordem_lanc: 999999, 
                        prec: false, 
                    };

                    let campo_qtd = "in_quantidade";

                    switch (this.num_contagem) {
                        case '1':
                        case '2':
                        case '3':
                            campo_qtd = 'in_contagem_' + this.num_contagem;
                            break;
                    }

                    item_inclusao[campo_qtd] = _.get(novo_item, 'quantidade');

                    this.contagem.estoque_inventario_items.push(item_inclusao);

                    this.$util.loadItem(this, { 
                        service: "estoque_items",
                        id: novo_item.id_estoque_item, 
                        parms: { 
                            ultima_entrada: true, 
                        }
                    })
                    .then(res => { 
                        if ( res.ultima_entrada ) { 
                            novo_item.ultima_entrada = res.ultima_entrada;
                        }
                        
                        this.$forceUpdate();
                    });

                }

            }

            this.$nextTick(() => {
                this.novo_item = "";
            });
        },

        lancar_contagem (item, refresh = false) {
            // this.num_contagem = "";
            // this.filtro_contagem = "";
            this.finalizando = false;
            this.search_items = "";

            if ( !refresh ) {
                this.contagem = null;
            }

            this.em_edicao = true;

            this.$util.load(this, {
                service: "estoque_inventarios.show",
                parms: {
                    id: item.id_estoque_inventario,
                    id_estoque_local: item.id_estoque_local,
                    contagem: true,
                },
                loadTo: res => {
                    this.contagem = res;

                    if ( this.$route.path != '/suprimentos/inventario/' + this.contagem.id_estoque_inventario ) {
                        this.$router.push({path: '/suprimentos/inventario/' + this.contagem.id_estoque_inventario});
                    }

                    this.$nextTick(() => {
                        this.editado = false;
                    });
                },
                final: () => { 
                    this.$nextTick(() => {
                        this.editado = false;
                    });
                }
            });

        },

        fechar() {
            this.contagem = null;
            this.em_edicao = false;

            if ( this.$route.path != '/suprimentos/inventario' ) {
                this.$router.push({path: '/suprimentos/inventario'});
            }
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        clonar (base) {

            this.validate = false;

            let item = {
                id_estoque_inventario: null,
                id_estoque_local: base.id_estoque_local,
                st_titulo: base.st_titulo,
                st_observacao: base.st_observacao,
                fl_ativo: true,
                id_estoque_inventario_clone: base.id_estoque_inventario,
                estoque_inventario_items: _.uniq(
                    base.estoque_inventario_items.map(eii => {
                        return {
                            id_estoque_item: eii.id_estoque_item,
                            excluido: false,
                        }
                    })
                )
            };

            this.editar (item);

        },

        incluir () {
            this.validate = false;

            let item = {
                id_estoque_inventario: null,
                id_estoque_local: this.filtros.id_estoque_local,
                st_observacao: "",
                fl_ativo: true,
            };

            this.editar (item);
        },

        load () {

            this.$store.commit('loading', true);

            this.$util.setCookie('estoque-armazem', this.filtros.id_estoque_local);

            this.$util.load(this, {
                service: 'estoque_inventarios.index',
                parms: {
                    ...this.filtros,
                    busca: this.search, 
                    lista_inventario: true, 
                }
            });

        },

        editar (item) {
            this.validate = false;
            this.item = _.cloneDeep (item);
            $('#edicaoModal').modal('show');
        },

        atualizar () {

            this.$util.atualizar(this, {
                service: 'estoque_inventarios',
                dados: {
                    ...this.item
                },
                modal: 'edicaoModal',
                reload: true,
                callback: res => {
                    this.filtros.id_estoque_local = this.item.id_estoque_local;
                    this.validate = false;

                    if ( this.item.id_estoque_inventario_clone ) {
                        this.lancar_contagem(res);
                    }
                }
            });

        },

        toggle (item) {

            this.$store.commit('loading', true);

            let query = { q: [
                {
                    name: 'estoque_inventarios.toggle',
                    id: 'toggle',
                    parms: {
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => {
                    if ( res.data.toggle.status == 200 ) {
                        //
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

        },
        format (n) {
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () {

        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Inventário", path: "/suprimentos/inventario" }
        ]);

        this.$util.loadItem(this, {
            service: 'estoque_items',
            func: 'tags',
        })
        .then(res => {
            this.options_classes = res;
        });

        this.load ();

        if ( this.$route.params.id ) {
            this.lancar_contagem({ id_estoque_inventario: this.$route.params.id });
        }
    },

    updated () {
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>
